// Copyright (c) 2016 Deere & Company

import PinsNotRegistered from './components/pins-not-registered-report';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.reports.pinsNotRegistered,
    columnApi: state.columnApi,
    generalSettings: state.user.details.settings.general,
    gridApi: state.gridApi,
    isDefaultColumnStateAvailable: state.reportVariant.layouts.length ? Boolean(state.reportVariant.layouts.find(layout => layout.name === '').columnState.length) : false,
    isInitialLoad: state.reportVariant.isInitialLoad,
    isReportColumnsVisible: state.reportVariant.isReportColumnsVisible,
    layouts: state.reportVariant.layouts,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts,
    selectedLayout: state.reportVariant.selectedLayout
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams, location} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        pathName: location.pathname,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PinsNotRegistered);



// WEBPACK FOOTER //
// ./src/reports/pins-not-registered/state-connector.js